module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"")
    ; __append(escapeFn(id))
    ; __append("\" class=\"formula-function\" data-kind=\"")
    ; __append(escapeFn(kind))
    ; __append("\" data-type=\"")
    ; __append(escapeFn(type))
    ; __append("\" >\r\n    <div class=\"formula-item function-name noselect\" data-kind=\"")
    ; __append(escapeFn(kind))
    ; __append("\" >")
    ; __append(escapeFn(functionName))
    ; __append(" (</div>\r\n\r\n    ")
    ; 
     if (functionParameters) {
         _.forEach(functionParameters, function(params) {
            if (params.name != "") {
      
    ; __append("\r\n        <div class=\"formula-item formula-function-item noselect\" data-kind=\"")
    ; __append(escapeFn(kind))
    ; __append("\" >")
    ; __append(escapeFn(params.name))
    ; __append(":</div>\r\n            ")
    ; 
            if (params.children) {
            _.forEach(params.children  , function(child) {

                var displayValue = child.value;
                if (child.kind === 'argument' && child.type === 'scripting_literal') {
                    if (child.value === '') { displayValue = '[empty]'; }
                    else if (!$.isNumeric(child.value)) {
                        displayValue = '"' + child.value + '"';
                    }
                }
                if (child.type === 'scripting_special') {
                    displayValue = child.displayValue;
                }
            
    ; __append("\r\n            <div id=\"")
    ; __append(escapeFn(child.id))
    ; __append("\" class=\"formula-item noselect\" data-kind=\"")
    ; __append(escapeFn(child.kind))
    ; __append("\" data-paramType=\"")
    ; __append(escapeFn(params.name))
    ; __append("\" data-type=\"")
    ; __append(escapeFn(child.type))
    ; __append("\">")
    ; __append(escapeFn(displayValue))
    ; __append("</div>\r\n\r\n            ")
    ; 
            });
            }
            }
        });
        }
        
    ; __append("\r\n    <div class=\"formula-item noselect\" data-kind=\"")
    ; __append(escapeFn(kind))
    ; __append("\" >)</div>\r\n</div>")
  }
  return __output;

}